module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-box"
  }, [_c('el-row', [_c('p', {}, [_vm._v("\n        " + _vm._s(_vm.data.label) + "\n      ")])]), _vm._v(" "), _c('el-form-item', [_c('el-switch', {
    staticStyle: {
      "--el-switch-on-color": "#13ce66",
      "--el-switch-off-color": "#ff4949"
    },
    attrs: {
      "disabled": _vm.disabled,
      "size": "",
      "active-text": "Si",
      "inactive-text": "No"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.model, _vm.data.name)
      }
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d8a8eae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/SwitchDetraction.vue
// module id = 630
// module chunks = 1